<template>
	<div id="app">
		<!-- 主内容区 -->
		<main>
			<router-view />
		</main>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: Arial, sans-serif;
	}

	.nodata {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 1200px;
		padding: 20px;
	}

	.nodata img {
		width: 180px;
		height: 180px;
	}

	.nodata span {
		padding-top: 20px;
		color: #999;
		font-size: 16px;
	}

	/* 加载中动画效果 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 10px;
	}

	.loading-more .el-icon-loading {
		font-size: 24px;
		color: #666;
		animation: rotating 2s linear infinite;
	}

	.loading-more span {
		margin-left: 10px;
		color: #999;
		font-size: 16px;
	}

	/* 已全部加载样式 */
	.load-all {
		font-size: 16px;
		padding: 10px 0;
	}

	@media (max-width: 768px) {
		.nodata {
			width: 95vw;
			padding: 0;
			margin-top: 50px !important;
		}
	}

	@media (max-width: 480px) {
		.nodata {
			width: 95vw;
			padding: 0;
			margin-top: 50px !important;
		}
	}

	.el-dialog__header {
		background-color: var(--background-color) !important;
	}
	
	.el-dialog__body {
		background-color: var(--background-color) !important;
	}
	
	.el-dialog__footer {
		background-color: var(--background-color) !important;
	}
	
	.el-dialog__title {
		color: var(--link-color) !important;
	}
</style>